
define('controllers/myaccount/balance/refund-detail.ctrl',['app','mainCons'], function (app,mainCons) {
    //订单详情contorller
    app.controller('RefundDetailCtrl', ['$q','$scope', 'OpenOther','OpenTrade','OpenApp', '$stateParams', 'auiDialog',
        function ($q,$scope, OpenOther,OpenTrade,OpenApp, $stateParams,auiDialog) {
            //获取订单ID
            $scope.orderId =$stateParams.orderId;
            var signParty = $scope.signParty = [$stateParams.signParty * 1];
            $scope.currencyUnit = mainCons.balanceConstant.currentUnits[$scope.signParty];
            $scope.refundReasonsFormatter =mainCons.balanceConstant.refundReasonsFormatter;
            $scope.refundStatus =mainCons.balanceConstant.refundStatus;
            $scope.receiptStatus =mainCons.balanceConstant.receiptStatus;
            $scope.refundReceiptStatus =mainCons.balanceConstant.refundReceiptStatus;
            $scope.refundType = mainCons.balanceConstant.refundType;
            $scope.refundInfoList=[];
            $scope.refundInfo = {};
            getRefundDetailList();

            var orderMoney1 =$stateParams.orderMoney;
            //路由有金额传入，则接受
            if(!orderMoney1){
                getOrderDetail($stateParams.orderId)
            }else{
                $scope.orderMoney =orderMoney1;
            }

            function getRefundDetailList(){
                //调用接口获取订单详情
                OpenTrade.getRefundDetailList({req:{orderId: $scope.orderId}}).then(function (res) {
                    if (res) {
                        $scope.refundInfoList = res.refundInfoList;
                        if($scope.refundInfoList.length){
                            $scope.refundInfo =  $scope.refundInfoList[0];
                            $scope.orderInfo =  $scope.refundInfoList[0].orderInfo;

                        }

                    }
                });
            }
            $scope.queryRefundDetail = function (orderId){
                var refundInfoList = $scope.refundInfoList;
                for(var i=0;i<refundInfoList.length;i++ ){
                    if(refundInfoList[i].orderInfo.orderId == orderId){
                        $scope.refundInfo = refundInfoList[i];
                        $scope.orderInfo =  refundInfoList[i].orderInfo;
                    }
                }
            }
            //刷新时接口查询获取充值金额
            function getOrderDetail(orderId){
                var getOrderListRequest ={
                    signPartys:($stateParams.signParty == 1 ? [1,4] : signParty),
                    fromRecCount: 1,
                    searchTxt: orderId,
                }
                //调用接口获取订单详情
                OpenTrade.getOrderList({req: getOrderListRequest}, true).then(function (data) {
                    var orderList = data && data.orderList;
                    if (orderList && orderList.length > 0) {
                        $scope.orderMoney = orderList[0].money;
                    }
                });
            }
            //撤销事件
            $scope.revokeRefundOrder = function (orderId){
                var defer = $q.defer();
                auiDialog.confirm('确认要撤销退款吗？', function () {
                    OpenTrade.revokeRefundOrder({req: {orderId: orderId}}).then(function (res) {
                        if (res && res.retCode == 0) {
                            auiDialog.success("撤销退款成功。", function () {
                                //刷新页面
                                defer.resolve();
                                getRefundDetailList();
                            });
                        }
                    }).catch(function () {
                        defer.reject();
                    });
                }, function () {
                    defer.reject();
                });
                return defer.promise;
            }


    }]);
});

